import { Container, Grid, Group, Text, Stack, Anchor, Image, Box } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Link } from 'react-router-dom';
import { FeedbackModal } from '../Support/FeedbackModal';
import { useAuth } from '../../hooks/useAuth';
import { BrandWordmark } from '../UI/BrandWordmark';

export const AppFooter = () => {
  const currentYear = new Date().getFullYear();
  const { user } = useAuth();
  const [feedbackOpened, { open: openFeedback, close: closeFeedback }] = useDisclosure(false);

  return (
    <Box bg="dark" py={{ base: 40, md: 60 }}>
      <Container size="lg" px={{ base: "xl", lg: "md" }}>
        {/* Desktop Layout */}
        <Grid gutter="xl" visibleFrom="md">
          <Grid.Col span={6}>
            <Stack gap="md">
              <BrandWordmark c="white" />
              <Text c="gray.5" maw={400}>
                Meal plans built around your life — your diet, your schedule,
                your pantry, your tastes.
              </Text>
              <Group gap="sm" align="center">
                <Group gap="xs" align="center">
                  <Image 
                    src="/images/longmont_small.png" 
                    alt="Longmont"
                    w={16}
                    h={16}
                    style={{ 
                      objectFit: 'contain',
                      filter: 'brightness(1.5) contrast(1.2)'
                    }}
                  />
                  <Text size="sm" c="gray.5">
                    Made in Longmont
                  </Text>
                </Group>
                <Text c="gray.6" size="sm">•</Text>
                <Text c="gray.5" size="sm">© {currentYear} Meals You Love</Text>
              </Group>
            </Stack>
          </Grid.Col>
          
          <Grid.Col span={3}>
            <Stack gap="sm">
              <Text fw={500} c="white">Company</Text>
              <Anchor component={Link} to="/about" c="gray.5" size="sm">
                About
              </Anchor>
              {user ? (
                <Anchor
                  component="button"
                  onClick={openFeedback}
                  c="gray.5"
                  size="sm"
                  style={{ 
                    background: 'none', 
                    border: 'none', 
                    padding: 0,
                    textAlign: 'left',
                    cursor: 'pointer'
                  }}
                >
                  Contact us
                </Anchor>
              ) : (
                <Anchor
                  href="mailto:hello@mealsyoulove.com"
                  c="gray.5"
                  size="sm"
                >
                  Contact us
                </Anchor>
              )}
            </Stack>
          </Grid.Col>
          
          <Grid.Col span={3}>
            <Stack gap="sm">
              <Text fw={500} c="white">Legal</Text>
              <Anchor component={Link} to="/privacy" c="gray.5" size="sm">
                Privacy Policy
              </Anchor>
              <Anchor component={Link} to="/terms" c="gray.5" size="sm">
                Terms of Service
              </Anchor>
              <Anchor component={Link} to="/cookies" c="gray.5" size="sm">
                Cookie Policy
              </Anchor>
            </Stack>
          </Grid.Col>
        </Grid>

        {/* Mobile Layout */}
        <Stack gap="lg" hiddenFrom="md">
          <BrandWordmark c="white" />
          <Text c="gray.5">
                Meal plans built around your life — your diet, your schedule,
                your pantry, your tastes.
          </Text>
          
          <Group gap="xl" align="flex-start" grow>
            <Stack gap="sm">
              <Text fw={500} c="white">Company</Text>
              <Anchor component={Link} to="/about" c="gray.5" size="sm">
                About
              </Anchor>
              {user ? (
                <Anchor
                  component="button"
                  onClick={openFeedback}
                  c="gray.5"
                  size="sm"
                  style={{ 
                    background: 'none', 
                    border: 'none', 
                    padding: 0,
                    textAlign: 'left',
                    cursor: 'pointer'
                  }}
                >
                  Contact us
                </Anchor>
              ) : (
                <Anchor
                  href="mailto:hello@mealsyoulove.com"
                  c="gray.5"
                  size="sm"
                >
                  Contact us
                </Anchor>
              )}
            </Stack>
            
            <Stack gap="sm">
              <Text fw={500} c="white">Legal</Text>
              <Anchor component={Link} to="/privacy" c="gray.5" size="sm">
                Privacy Policy
              </Anchor>
              <Anchor component={Link} to="/terms" c="gray.5" size="sm">
                Terms of Service
              </Anchor>
              <Anchor component={Link} to="/cookies" c="gray.5" size="sm">
                Cookie Policy
              </Anchor>
            </Stack>
          </Group>

          {/* No "•" separator here: below ~430px this row wraps and the
              bullet ends up orphaned at the end of the first line */}
          <Group gap="sm" align="center" justify="center">
            <Group gap="xs" align="center">
              <Image
                src="/images/longmont_small.png"
                alt="Longmont"
                w={16}
                h={16}
                style={{
                  objectFit: 'contain',
                  filter: 'brightness(1.5) contrast(1.2)'
                }}
              />
              <Text size="sm" c="gray.5">
                Made in Longmont
              </Text>
            </Group>
            <Text c="gray.5" size="sm">© {currentYear} Meals You Love</Text>
          </Group>
        </Stack>
      </Container>
      
      <FeedbackModal opened={feedbackOpened} onClose={closeFeedback} />
    </Box>
  );
};
